import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavBar } from 'app-components';
export const useTopNavMenu = (userActiveRole, roleLabel, roleLabels, roles, role, endpoints) => {

    const [activeRoleLabel, setActiveRoleLabel] = useState(roleLabel);
    const handleChangeRole = (newRoleLabel) => {
        sessionStorage.setItem('userActiveRoleLabel', newRoleLabel);
        setActiveRoleLabel(newRoleLabel);
    };
    const sortedRoleLabels = Object.entries(roleLabels).sort(([, valueA], [, valueB]) => valueA.localeCompare(valueB));
    const selectedRole = Object.keys(roleLabels).find(key => roleLabels[key] === roleLabel);
    const TopNavMenuComponent = () => {
        return (
            <NavBar>
                <NavBar.Item>
                    <NavBar.Menu
                        id='rolesList'
                        iconName={selectedRole === role ? 'key' : undefined}
                        label={`${activeRoleLabel} ( Change`}
                    >
                        <NavBar.SubMenuItem
                            id='my-role'
                            labelId={'header.myRole'}
                        />
                        {sortedRoleLabels.map(([roleKey, roleValue]) => (
                            <NavBar.SubMenuItem
                                key={roleKey}
                                id={roleKey}
                                isShowInNewTab={false}
                                url={endpoints.HEADER_ROLES_LINK.processReplacements({ encryptedRoleName: roles[roleKey] })}
                                render={() => (
                                    <Fragment>
                                        <a
                                            href={endpoints.HEADER_ROLES_LINK.processReplacements({ encryptedRoleName: roles[roleKey] })}
                                            data-automation-id={roleKey}
                                            target={'_self'}
                                            rel="noopener noreferrer"
                                            title={<FormattedMessage id='common.link.title.newTab' />}
                                        >
                                            {roleValue === activeRoleLabel && <FontAwesomeIcon icon="check" data-automation-id={`icon${roleKey}`} />}&nbsp;
                                            {roleKey === role && <FontAwesomeIcon icon="key" data-automation-id={`icon${roleKey}`} />}&nbsp;
                                            <span>{roleValue}</span>
                                        </a>
                                    </Fragment>
                                )}
                            />
                        ))}
                    </NavBar.Menu>
                    <span className='additional-content'>)</span>
                </NavBar.Item>
            </NavBar>
        );
    };

    return { TopNavMenuComponent, activeRoleLabel, handleChangeRole };
};
